module.exports = __webpack_public_path__ + "img/3.3港口-1.af242a8c.png";